import { normalizarHabilidadeId } from '../../lib/skillAliases.js';

export function adaptarAvaliacao(avaliacao) {
  if (!avaliacao) return null;
  const fonte = avaliacao.pontuacoes || avaliacao.habilidades || {};
  const habilidades = Object.fromEntries(Object.entries(fonte).map(([id, valor]) => [normalizarHabilidadeId(id), valor]));
  return { ...avaliacao, habilidades };
}

export function adaptarAvaliacoes(lista = []) {
  return lista.map(adaptarAvaliacao).filter(Boolean);
}
